export default [{
  path: '/montagens-ais-incrementais',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Montagem AIS Incremental Histórico',
      path: 'historico',
      component: () => import('@/views/montagensAisIncrementais/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Laudo Express' }
        ]
      }
    },
    {
      name: 'Montagem AIS Incremental Upload',
      path: 'novo',
      component: () => import('@/views/montagensAisIncrementais/Upload.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Laudo Express', path: '/montagens-ais-incrementais/historico' },
          { name: 'Nova Execução' }
        ]
      }
    }
  ]
}];
